import { environment } from '../../environments/environment';

/**
 * API configuration constants for the BFG CRM system
 */

export const API_CONFIG = {
  BASE_URL: environment.apiUrl,
  TIMEOUT: 30000, // 30 seconds
} as const;

export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: '/auth/login',
    USERS: '/auth/users',
    CALL_CENTER_USERS: '/auth/call-center-users',
    UPDATE_USERNAME: '/auth/update-username',
    CHANGE_PASSWORD: '/auth/change-password',
    JOB_TITLES: '/auth/jobtitles',
    INSURANCE_COMPANIES: '/auth/insurancecompanies',
    PRODUCTS: '/auth/products',
  },

  // Customer management endpoints
  CUSTOMERS: {
    BASE: '/customers',
    LIST: '/customers/list',
    CREATE: '/customers/create',
    UPDATE: '/customers/update',
    DELETE: '/customers/delete',
  },

  // Contract management endpoints
  CONTRACTS: {
    BASE: '/contracts',
    LIST: '/contracts/list',
    CREATE: '/contracts/create',
    UPDATE: '/contracts/update',
    DELETE: '/contracts/delete',
  },

  // Database management endpoints
  DATABASE: {
    BASE: '/database',
    COMPANIES: '/database/companies',
    CUSTOMERS: '/database/customers',
    INTERACTIONS: '/database/interactions',
  },

  // Upload endpoints
  UPLOAD: {
    BASE: '/upload',
    FILE: '/upload/file',
    PROCESS: '/upload/process',
  },

  // Backup endpoints
  BACKUP: {
    BASE: '/backup',
    CREATE: '/backup/create',
    RESTORE: '/backup/restore',
    LIST: '/backup/list',
  },

  // Illustrations endpoints
  ILLUSTRATIONS: {
    BASE: '/illustrations',
    LIST: '/illustrations/list',
    CREATE: '/illustrations/create',
    UPDATE: '/illustrations/update',
    DELETE: '/illustrations/delete',
  },

  // Call center stats endpoints
  CALL_CENTER_STATS: {
    BASE: '/call-center-stats',
    LIST: '/call-center-stats/list',
    UPDATE: '/call-center-stats/update',
    USER_STATS: '/call-center-stats/user',
  },
} as const;

/**
 * Helper function to build full API URLs
 */
export function buildApiUrl(endpoint: string): string {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
}

/**
 * HTTP request configuration constants
 */
export const HTTP_CONFIG = {
  HEADERS: {
    CONTENT_TYPE: 'application/json',
    ACCEPT: 'application/json',
  },
  RETRY_COUNT: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_DATA: 'userData',
  THEME: 'theme',
  LANGUAGE: 'language',
} as const;